"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SvgEllipsisIcon = (0, react_1.forwardRef)((props, ref) => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 6', ref: ref }, props, { children: (0, jsx_runtime_1.jsx)("path", { fill: 'currentColor', fillRule: 'nonzero', d: 'M0 3c0-1.657 1.45-3 3.24-3s3.241 1.343 3.241 3-1.45 3-3.24 3S0 4.657 0 3m9.26 0c0-1.657 1.45-3 3.24-3s3.24 1.343 3.24 3-1.45 3-3.24 3-3.24-1.343-3.24-3m12.5-3C23.55 0 25 1.343 25 3s-1.45 3-3.24 3-3.241-1.343-3.241-3 1.45-3 3.24-3' }) })));
});
exports.default = (0, react_1.memo)(SvgEllipsisIcon);
